module.exports = __webpack_public_path__ + "media/images/users/itu-fe873b8e0b8b0ff0075f6d9c40b0225a.png";